const amountOfTasksOnPage = 30;

export default amountOfTasksOnPage;
